export default __webpack_public_path__ + "static/media/bannerRastreador.abef234c.svg";